import { LngLatBounds } from "mapbox-gl";

export const TOGGLE_LINK_CLICKABILITY = "TOGGLE_LINK_CLICKABILITY";
export const SET_CURRENT_BOUNDS = "SET_CURRENT_BOUNDS";
export const SET_LINK_CONFIRMED = "SET_LINK_CONFIRMED";

export interface ToggleLinkClickabilityAction {
    type: typeof TOGGLE_LINK_CLICKABILITY;
    payload: { isLinkClickable: boolean };
}

export interface SetLinkConfirmedAction {
    type: typeof SET_LINK_CONFIRMED;
    payload: { isLinkConfirmed: boolean };
}
export interface SetCurrentBoundsAction {
    type: typeof SET_CURRENT_BOUNDS;
    payload: { currentBounds: LngLatBounds };
}
export interface RegulationMapState {
    isLinkClickable: boolean;
    currentBounds: LngLatBounds | null;
    linkConfirmed: boolean;
}

export type RegulationMapActions =
    | ToggleLinkClickabilityAction
    | SetCurrentBoundsAction
    | SetLinkConfirmedAction;
